import { Card, Col, Typography, Button, List, Space } from "antd"
import {
  FolderOutlined,
  ReloadOutlined,
} from "@ant-design/icons"

const { Text } = Typography

const ExecutionMemory = () => {
  // Execution Memory Data
  const executionMemoryData = [
    {
      pattern: "Vendor switches",
      successRate: "85%",
      avgSavings: "$310K",
      frequency: "Last 3 implementations",
    },
    {
      pattern: "Growth ops with delayed GTM",
      successRate: "22%",
      avgSavings: "-$150K",
      frequency: "78% failure rate",
    },
  ]
  
  return (
    <Col xs={24} lg={12}>
          <Card
            title={
              <Space>
                <FolderOutlined style={{ color: "#13c2c2" }} />
                <span>Execution Memory + Pattern Recognition</span>
              </Space>
            }
          >
            <List
              dataSource={executionMemoryData}
              renderItem={(item) => (
                <List.Item
                  key={item.pattern}
                  actions={[
                    <Button type="link" icon={<ReloadOutlined />}>
                      Re-deploy
                    </Button>,
                  ]}
                >
                  <List.Item.Meta
                    title={item.pattern}
                    description={
                      <Space direction="vertical">
                        <Text>
                          Success Rate: <Text strong>{item.successRate}</Text>
                        </Text>
                        <Text>
                          Avg Impact: <Text strong>{item.avgSavings}</Text>
                        </Text>
                        <Text type="secondary">{item.frequency}</Text>
                      </Space>
                    }
                  />
                </List.Item>
              )}
            />
          </Card>
        </Col>
  )
}

export default ExecutionMemory